module.exports = __webpack_public_path__ + "static/img/female-bg-es.d3102679.png";